import { msUtil } from 'core/ms_util.js'
window.timeClock = (function ($, global) {
  // Component visibility management functions
  var showComponent = function (selector) {
    var element = document.querySelector(selector)
    if (!element) {
      return false
    }

    // First remove any inline styles that might override class rules
    element.removeAttribute('style')
    // Then apply the active class
    element.classList.add('active')
    // Ensure display is set correctly
    element.style.display = 'block'
    return true
  }

  var hideComponent = function (selector) {
    var element = document.querySelector(selector)
    if (!element) {
      return false
    }

    // Remove the active class
    element.classList.remove('active')
    // Explicitly set display: none to ensure it's hidden
    element.style.display = 'none'
    return true
  }

  var nextShift
  var position
  var currentPunch
  var currentUser
  var departments
  var locations
  var job_sites
  var positions
  var breakPunch
  var timeoutInterval
  var flashInterval
  var clearIDInterval
  var clearPasswordInterval
  var employeeIDInterval
  var timeoutLength = 15000
  var initialized = false
  var countdownTimerLength = 14000
  var countdownInterval

  var initTimeClock = function () {
    moment.locale(I18n.locale)

    if (!initialized) {
      init()

      //back button killer so users in safari can't use the back button to go
      //through history and access the admin tools. (Of course this won't stop
      //someone from viewing the browser history and going in that way, server
      //side session checks should prevent that method).
      var _hash = '!'
      var noBackPlease = function () {
        global.location.href += '#'
        global.setTimeout(function () {
          global.location.href += '!'
        }, 50)
      }

      global.onhashchange = function () {
        if (global.location.hash !== _hash) {
          global.location.hash = _hash
        }
      }

      global.onload = function () {
        noBackPlease()

        // disables backspace on page except on input fields and textarea..
        document.body.onkeydown = function (e) {
          var elm = e.target.nodeName.toLowerCase()
          if (e.which === 8 && elm !== 'input' && elm !== 'textarea') {
            e.preventDefault()
          }
          e.stopPropagation()
        }
      }
    }
  }

  var init = function () {
    if (!initialized) {
      initialized = true
      updateClock()
      setInterval(updateClock, 1000)

      initializeButtons()
      resetClockInFlow()
      initAjaxSetup()

      $(document).off('load.time_clock.show', init)
      $(document).off('load.time_clock.time_clock_sign_out.show', init)
    }
  }

  var initAjaxSetup = function () {
    $.ajaxSetup({
      complete: function (jqXHR, textStatus, errorThrown) {
        if (jqXHR.status == 401) {
          location.reload()
        }
      }
    })
  }

  var setClockInButtonLabel = function (label) {
    var punchInButton = $('body.time_clock .clock-in-employee-id')
    if (_.isElement(punchInButton[0])) {
      punchInButton.html(label)
    }
  }

  var resetClockInFlow = function (skipResetFlash) {
    // Reset UI
    $('body.time_clock .next-employee-id').addClass('active')
    $('body.time_clock .employee-id-lookup').addClass('active')
    $('body.time_clock .punch-card').removeClass('active')
    $('body.time_clock .punch-in-card').removeClass('active')
    $('body.time_clock .punch-out-card').removeClass('active')
    $('body.time_clock .start-break-card').each(function () {
      $(this).removeClass('active')
    })
    $('body.time_clock span.title').html('&nbsp;')

    // Reset transfer-related elements - first hide all transfer elements
    var $transferOptionsCard = $('body.time_clock .transfer-options-card')
    if ($transferOptionsCard.length) {
      $transferOptionsCard.removeClass('active').hide()
    }

    var $upcomingShiftsContainer = $('.upcoming-shifts-container')
    if ($upcomingShiftsContainer.length) {
      $upcomingShiftsContainer.removeClass('active').hide()
    }

    $('.separate-sections li:first-child').show()
    $('.separate-sections').show()

    // Always reset button visibility
    $('.normal-buttons').removeClass('hidden')

    var $submitButton = $('body.time_clock .submit-employee-id')
    if ($submitButton.length) {
      $submitButton
        .text(I18n.t('buttons.submit'))
        .attr('data-transfer-button', 'false')
        .off('click', submitUnscheduledTransfer)
        .on('click', onEmployeeFormSubmit)
    }

    // Reset transfer mode flag
    window.transfer_mode = false

    if ($('body.time_clock.time_clock_sign_out').length === 0) {
      $('.separate-sections li:last-child').removeClass('active')
    }

    $('.time-interval-warning label').text('')

    // Clear idField
    clearEmployeeID()

    // Select2 operations
    $('body.time_clock #time-clock-department-filter').select2('close')
    $('body.time_clock #time-clock-job-site-filter').select2('close')
    $('body.time_clock #time-clock-position-filter').select2('close')

    var $idField = $('body.time_clock input[name="employee_id"]')
    $idField.removeAttr('disabled')

    clearEmployeeIDInterval()

    // Clear data store
    nextShift = null
    position = null
    currentPunch = null
    currentUser = null
    departments = null
    locations = null
    job_sites = null
    positions = null
    window.selectedShiftForTransfer = null

    setClockInButtonLabel(I18n.t('timeclock.js.clock_in'))

    // Clear department select box
    $('body.time_clock #time-clock-department-filter').val($('body.time_clock #time-clock-department-filter option:first').val())

    $('body.time_clock .position').html('')
    $('body.time_clock .job_site').html('')
    $('body.time_clock .breaks').html('')

    // Clear any living reset timeouts
    clearTimeOut()
    clearEmployeeInterval()

    if (!skipResetFlash) {
      clearFlashInterval()
    }
  }

  //get initial server time, and updated it by 1000ms every second.
  var updateClock = function () {
    //null check clock time if it isn't instantiated yet
    if (typeof document.ctoday !== 'undefined') {
      var utcSeconds = Date.now() / 1000
      //create new epoch date
      var d = new Date(0)

      var currentTime = new Date(d.setUTCSeconds(utcSeconds))
      var currentHours = currentTime.getHours()
      var currentMinutes = currentTime.getMinutes()
      var currentSeconds = currentTime.getSeconds()

      //pad with zeros
      currentMinutes = (currentMinutes < 10 ? '0' : '') + currentMinutes
      currentSeconds = (currentSeconds < 10 ? '0' : '') + currentSeconds

      var timeOfDay = currentHours < 12 ? I18n.t('time.am') : I18n.t('time.pm')
      currentHours = currentHours > 12 ? currentHours - 12 : currentHours
      currentHours = currentHours == 0 ? 12 : currentHours

      var currentTimeString = currentHours + ':' + currentMinutes + ':' + currentSeconds + ' '

      var timeOfDayElement = document.getElementById('time_of_day')
      if (timeOfDayElement == null) {
        timeOfDayElement = document.createElement('span')
        var timeAttribute = document.createAttribute('id')
        timeAttribute.value = 'time_of_day'
        timeOfDayElement.setAttributeNode(timeAttribute)
      }
      timeOfDayElement.innerHTML = timeOfDay

      var domTime = document.getElementById('time-clock-active-clock')
      if (typeof domTime !== 'undefined') {
        document.getElementById('time-clock-active-clock').firstChild.nodeValue = currentTimeString
        document.getElementById('time-clock-active-clock').appendChild(timeOfDayElement)
      }
    }
  }

  var initializeButtons = function () {
    var nextButton = $('body.time_clock .next-employee-id')
    if (_.isElement(nextButton[0])) {
      nextButton.on('click', validateEmployeeIdEntry)
    }

    // Add handlers for transfer buttons
    var transferButton = $('body.time_clock .transfer-employee-id')
    if (_.isElement(transferButton[0])) {
      transferButton.on('click', showTransferOptions)
    }

    var upcomingShiftButton = $('body.time_clock .select-upcoming-shift')
    if (_.isElement(upcomingShiftButton[0])) {
      upcomingShiftButton.on('click', showUpcomingShifts)
    }

    var unscheduledShiftButton = $('body.time_clock .select-unscheduled-shift')
    if (_.isElement(unscheduledShiftButton[0])) {
      unscheduledShiftButton.on('click', showUnscheduledShiftOptions)
    }

    var cancelTransferButton = $('body.time_clock .cancel-transfer')
    if (_.isElement(cancelTransferButton[0])) {
      cancelTransferButton.on('click', cancelTransfer)
    }

    var submitButton = $('body.time_clock .submit-employee-id')
    if (_.isElement(submitButton[0])) {
      submitButton.on('click', onEmployeeFormSubmit)
    }

    var idField = $('body.time_clock input[name="employee_id"]')
    if (_.isElement(idField[0])) {
      idField.on('input', onEmployeeIdInput)
    }

    var deptField = $('body.time_clock select#time-clock-department-filter')
    if (_.isElement(deptField[0])) {
      deptField.on('change', onEmployeeDeptSelection)
    }

    var startBreakButton = $('body.time_clock button.start-break')
    if (_.isElement(startBreakButton[0])) {
      startBreakButton.on('click', startBreakPunch)
    }

    var endBreakButton = $('body.time_clock button.end-break')
    if (_.isElement(endBreakButton[0])) {
      endBreakButton.on('click', endBreakPunch)
    }

    var punchOutButton = $('body.time_clock .clock-out-employee-id')
    if (_.isElement(punchOutButton[0])) {
      punchOutButton.on('click', punchOutEmployee)
    }

    var cancelPunchInButton = $('body.time_clock .cancel-clock-in')
    if (_.isElement(cancelPunchInButton[0])) {
      cancelPunchInButton.on('click', cancelPunchIn)
    }

    var cancelSubmitPunchInButton = $('body.time_clock .cancel-submit-clock-in')
    if (_.isElement(cancelSubmitPunchInButton[0])) {
      cancelSubmitPunchInButton.on('click', cancelPunchIn)
    }

    var punchInButton = $('body.time_clock .clock-in-employee-id')
    if (_.isElement(punchInButton[0])) {
      punchInButton.on('click', onPunchInClicked)
    }

    var employeeForm = $('body.time_clock form.employee-id-lookup')
    if (_.isElement(employeeForm[0])) {
      $('body.time_clock form.employee-id-lookup').submit(onEmployeeFormSubmit)
    }

    var departmentDrop = $('body.time_clock #time-clock-department-filter')
    if (_.isElement(departmentDrop[0])) {
      departmentDrop.on('select2-focus select2-blur select2-change change', setUpDepartmentTimeout)
    }

    var signOutButton = $('body.time_clock_sign_out button.btn.sign-out-employee-id')
    if (_.isElement(signOutButton[0])) {
      signOutButton.on('click', signOutOfTimeClock)
    }

    var signOutPasswordField = $('body.time_clock_sign_out #password')
    if (_.isElement(signOutPasswordField[0])) {
      signOutPasswordField.on('focus', function () {
        signOutPasswordField.on('keypress', onEnterTapped)
        signOutPasswordField.removeAttr('readonly')
      })

      signOutPasswordField.on('blur', function () {
        signOutPasswordField.off('keypress', onEnterTapped)
        signOutPasswordField.attr('readonly', 'readonly')
        signOutPasswordField.focus()
      })

      signOutPasswordField.on('input', function () {
        clearPasswordTimeout()
        //adding a comment to trigger a build.
        //this hack is so FF doesn't auto fill in the sign out password.
        if ($(this).attr('type') != 'password') {
          $(this).attr('type', 'password')
        }
      })

      signOutPasswordField.focus()
    }

    var passwordScreen = $('.time_clock.time_clock_sign_out.show')
    if (_.isElement(passwordScreen[0])) {
      setUpClearPasswordInterval()
    }
  }

  var onEnterTapped = function (e) {
    if (e.which === 13) {
      signOutOfTimeClock()
      e.preventDefault()
    }
  }

  var signOutOfTimeClock = function () {
    $('form#form-admin-sign-out').submit()
  }

  var onEmployeeFormSubmit = function (e) {
    if ($('.separate-sections li:last-child').hasClass('active')) {
      validateDepartmentSelection(e)
    } else {
      validateEmployeeIdEntry(e)
    }
    if (typeof e !== 'undefined') e.preventDefault()

    //re-enable clock in button
    $('body.time_clock .clock-in-employee-id').prop('disabled', false)
  }

  var validateEmployeeIdEntry = function (e) {
    var idField = $('body.time_clock input[name="employee_id"]')
    if (_.isElement(idField[0])) {
      if (idField.val().trim() == '') {
        displayFlashError(I18n.t('timeclock.js.valid_punch_id'))
        clearEmployeeIdInterval()
      } else {
        retrieveEmployeePunches(idField.val().trim())
      }
    }
    e.preventDefault()
  }

  var validateDepartmentSelection = function (e) {
    var deptField = $('body.time_clock select#time-clock-department-filter')
    var idField = $('body.time_clock input[name="employee_id"]')
    if (_.isElement(deptField[0])) {
      if (deptField.val().trim() == '') {
        displayFlashError(I18n.t('timeclock.js.please_select_dept'))
      } else {
        showShift()
      }
    }
  }

  var getBaseDomain = function () {
    return window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/'
  }

  var startBreakPunch = function (e) {
    $('body.time_clock button.start-break').prop('disabled', true)
    var url = getBaseDomain() + 'api/live/v3/kiosk_punches/' + currentPunch.id + '/start_break/?kiosk_desktop_mode=true'
    setEndpointHeaders()
    var sendData = {
      kiosk_punch: {
        user_id: currentUser.id.toString(),
        punch_id: currentPunch.id,
        shift_id: currentPunch.shift_id
      }
    }
    $.ajax({
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      url: url,
      data: JSON.stringify(sendData),
      success: onStartBreakPunchSuccess,
      error: onStartBreakPunchFail
    })
    clearTimeOut()
  }

  var onStartBreakPunchSuccess = function (response) {
    // Update break information from API
    if (response && response.break_punch) {
      breakPunch = response.break_punch
    }

    // Update transfer button visibility
    updateTransferButtonVisibility()
    displayFlashSuccess(
      I18n.t('timeclock.js.started_break_at_success', {
        user_name: '<strong>' + currentUser.name + '</strong>',
        time:
          '<strong>' +
          moment.unix(response.break_punch.starts_at).tz(getDepartmentTimeZone(response.punch.department_id)).format('h:mm A') +
          '</strong>'
      })
    )
    resetClockInFlow(true)
  }

  var onStartBreakPunchFail = function (error) {
    displayFlashError('Error: ' + error.responseJSON.error_message)
    timeoutInterval = setInterval(resetClockInFlow, 10000)
  }

  var endBreakPunch = function (e) {
    $('body.time_clock button.end-break').prop('disabled', true)
    var url = getBaseDomain() + 'api/live/v3/kiosk_punches/' + currentPunch.id + '/end_break/?kiosk_desktop_mode=true'
    setEndpointHeaders()
    var sendData = { kiosk_punch: { user_id: currentUser.id.toString(), punch_id: currentPunch.id } }
    $.ajax({
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      url: url,
      data: JSON.stringify(sendData),
      success: onEndBreakPunchSuccess,
      error: onEndBreakPunchFail
    })
    clearTimeOut()
  }

  var onEndBreakPunchSuccess = function (response) {
    displayFlashSuccess(
      I18n.t('timeclock.js.ended_break_at_success', {
        user_name: '<strong>' + currentUser.name + '</strong>',
        time:
          '<strong>' +
          moment.unix(response.break_punch.ends_at).tz(getDepartmentTimeZone(response.punch.department_id)).format('h:mm A') +
          '</strong>'
      })
    )
    resetClockInFlow(true)
    updateTransferButtonVisibility()
  }

  var onEndBreakPunchFail = function (error) {
    displayFlashError('Error: ' + error.responseJSON.error_message)
    timeoutInterval = setInterval(resetClockInFlow, 10000)
  }

  var punchOutEmployee = function (e) {
    $('body.time_clock button.clock-out-employee-id').prop('disabled', true)
    var url = getBaseDomain() + 'api/live/v3/kiosk_punches/' + currentPunch.id + '?kiosk_desktop_mode=true'
    setEndpointHeaders()
    var sendData = { kiosk_punch: { user_id: currentUser.id.toString() } }

    // Ensure transfer mode is reset
    window.transfer_mode = false

    try {
      $.ajax({
        method: 'PUT',
        dataType: 'json',
        contentType: 'application/json',
        url: url,
        data: JSON.stringify(sendData),
        success: function (response) {
          if (response) {
            onEmployeePunchedOutSuccess(response)
          }
        },
        error: onEmployeePunchedOutFail
      })
    } catch (error) {
      displayFlashError(I18n.t('errors.error', { message: 'An unexpected error occurred' }))
    }
    clearTimeOut()
  }

  var onEmployeePunchedOutSuccess = function (response) {
    displayFlashSuccess(
      I18n.t('timeclock.js.punch_out_success', {
        user_name: '<strong>' + currentUser.name + '</strong>',
        time:
          '<strong>' +
          moment.unix(response.punch.punched_out_at).tz(getDepartmentTimeZone(response.punch.department_id)).format('h:mm A') +
          '</strong>'
      })
    )
    resetClockInFlow(true)
  }

  var onEmployeePunchedOutFail = function (error) {
    displayFlashError(I18n.t('errors.error', { message: error.responseJSON.error_message }))
    timeoutInterval = setInterval(resetClockInFlow, 10000)
  }

  var cancelPunchIn = function (e) {
    clearFlashMessage()

    // If we're in transfer mode, handle differently
    if (window.transfer_mode) {
      // Hide department selection form
      $('form.employee-id-lookup').removeClass('active')
      $('.separate-sections li:last-child').removeClass('active')

      // Show the employee ID field again for future use
      $('.separate-sections li:first-child').show()

      // Show punch card with user info
      $('body.time_clock .punch-card').addClass('active')
      $('body.time_clock .punch-out-card').addClass('active')
      $('.normal-buttons').removeClass('hidden')

      // Reset transfer mode
      window.transfer_mode = false

      // Restore original submit button text and handler
      var submitButton = $('body.time_clock .submit-employee-id')
      submitButton.text(I18n.t('buttons.submit'))
      submitButton.attr('data-transfer-button', 'false')
      submitButton.off('click').on('click', onEmployeeFormSubmit)
    } else {
      // Normal behavior for regular clock-in
      resetClockInFlow()
    }

    e.preventDefault()
  }

  var onPunchInClicked = function (e) {
    var deptID = currentUser.department_ids[0]
    var job_site_id
    var position_id
    var punchInButton = $('body.time_clock .clock-in-employee-id')

    punchInButton.prop('disabled', true)

    if (nextShift != null) {
      deptID = nextShift.department_id
      job_site_id = nextShift.job_site_id
      position_id = nextShift.position_id
    } else {
      var deptField = $('body.time_clock select#time-clock-department-filter')
      deptID = deptField.val()
      job_site_id = $('body.time_clock select#time-clock-job-site-filter').val()
      position_id = $('body.time_clock select#time-clock-position-filter').val()
    }

    punchEmployee(currentUser.id.toString(), deptID.toString(), job_site_id, position_id)
  }

  var onEmployeeIdInput = function (e) {
    var idField = $('body.time_clock input[name="employee_id"]')
    if (_.isElement(idField[0])) {
      clearFlashMessage()
      clearEmployeeInterval()
      setUpTimeoutInterval()
    }
  }

  var onEmployeeDeptSelection = function (e) {
    var deptField = $('body.time_clock select#time-clock-department-filter')
    if (_.isElement(deptField[0])) {
      clearFlashMessage()
    }
  }

  var setEndpointHeaders = function () {
    $.ajaxSetup({
      beforeSend: function (xhr, options) {
        xhr.setRequestHeader('Authorization', 'Token ' + document.ctoken)
        return true
      },
      headers: {
        'X-APP-NAME': window.server_config.admin_mobile_app || 'makeshift_live',
        'X-APP-VERSION': '2.7.0',
        'X-DEVICE-TYPE': 'ios'
      }
    })
  }

  var punchEmployee = function (id, deptID, job_site_id, position_id) {
    var url = getBaseDomain() + 'api/live/v3/departments/' + deptID + '/kiosk_punches?kiosk_desktop_mode=true'
    setEndpointHeaders()
    var sendData = { kiosk_punch: { user_id: id, job_site_id: job_site_id, position_id: position_id } }
    if (nextShift != null) {
      sendData.kiosk_punch.shift_id = nextShift.id
    }
    $.ajax({
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      url: url,
      data: JSON.stringify(sendData),
      success: onEmployeePunchSuccess,
      error: onEmployeePunchFail
    })
    clearTimeOut()
  }

  var onEmployeePunchSuccess = function (response) {
    displayFlashSuccess(
      I18n.t('timeclock.js.punch_in_success', {
        user_name: '<strong>' + currentUser.name + '</strong>',
        time:
          '<strong>' +
          moment.unix(response.punch.punched_in_at).tz(getDepartmentTimeZone(response.punch.department_id)).format('h:mm A') +
          '</strong>'
      })
    )
    resetClockInFlow(true)
  }

  var onEmployeePunchFail = function (error) {
    displayFlashError('Error: ' + error.responseJSON.error_message)
    resetClockInFlow(true)
  }

  var retrieveEmployeePunches = function (id) {
    var url = getBaseDomain() + 'api/live/v3/kiosk_punches'
    setEndpointHeaders()
    $.ajax({
      method: 'GET',
      dataType: 'json',
      contentType: 'application/json',
      url: url,
      data: { user_lookup_key: id },
      success: onEmployeePunchRetrieveSuccess,
      error: onEmployeePunchRetrieveFail
    })
  }

  var getDepartmentTimeZone = function (id) {
    var dept = getDepartmentById(id)
    var loc = getLocationById(dept.location_id)
    return loc.time_zone
  }

  var getLocationById = function (id) {
    var len = locations.length
    var rtnLoc
    for (var i = 0; i < len; i++) {
      if (id == locations[i].id) {
        rtnLoc = locations[i]
        break
      }
    }
    return rtnLoc
  }

  var getLocationName = function (id) {
    var len = locations.length
    var rtnName
    for (var i = 0; i < len; i++) {
      if (id == locations[i].id) {
        rtnName = locations[i].name
        break
      }
    }
    return rtnName
  }

  var getDepartmentById = function (id) {
    var len = departments.length
    var rtnDept
    for (var i = 0; i < len; i++) {
      if (id == departments[i].id) {
        rtnDept = departments[i]
        break
      }
    }
    return rtnDept
  }

  var getDepartmentName = function (id) {
    var len = departments.length
    var rtnDept
    for (var i = 0; i < len; i++) {
      if (id == departments[i].id) {
        rtnDept = {
          name: departments[i].name,
          location_id: departments[i].location_id
        }
        break
      }
    }
    return rtnDept
  }

  var onEmployeePunchRetrieveSuccess = function (response) {
    window.transfer_mode = false
    currentUser = response.user
    departments = response.departments
    locations = response.locations
    position = response.position
    job_sites = response.job_sites
    positions = response.positions
    breakPunch = response.break_punch

    $('#title-with-job-site').hide()
    $('#title-with-position').hide()
    $('body.time_clock #time-clock-job-site-filter').select2('destroy')
    $('body.time_clock #time-clock-position-filter').select2('destroy')
    $('body.time_clock #time-clock-job-site-filter').hide()
    $('body.time_clock #time-clock-position-filter').hide()
    $('body.time_clock .clock-in-employee-id').prop('disabled', false)

    if (typeof response.shift !== 'undefined') {
      nextShift = response.shift
    }

    if (typeof response.punch !== 'undefined') {
      currentPunch = response.punch

      // Check if the punch is already marked as transferred in the response
      if (response.punch.is_transferred) {
        currentPunch.isTransferred = response.punch.is_transferred || false
      }

      showPunch()
    } else if (typeof response.shift !== 'undefined') {
      showShift()
    } else {
      var len = response.departments.length
      var job_sites_length = response.job_sites.length
      var positions_length = response.positions.length
      if (len == 0) {
        displayFlashError(I18n.t('timeclock.js.employee_not_eligible'))
        clearEmployeeIdInterval()
      } else {
        $('body.time_clock .next-employee-id').removeClass('active')
        $('body.time_clock .employee-id-lookup').addClass('active')
        $('body.time_clock .punch-card').removeClass('active')
        $('body.time_clock .punch-in-card').removeClass('active')
        $('body.time_clock .punch-out-card').removeClass('active')
        $('body.time_clock .start-break-card').removeClass('active')
        $('body.time_clock .start-break-card').removeClass('active')
        $('body.time_clock span.title').html('Clock In')

        var html = '<option></option>'
        for (var i = 0; i < len; i++) {
          html +=
            '<option value="' + response.departments[i].id + '">' + response.locations[i].name + ' - ' + response.departments[i].name + '</option>'
        }

        $('body.time_clock #time-clock-department-filter').html(html)

        $('body.time_clock #time-clock-department-filter')
          .select2({
            placeholder: I18n.t('timeclock.js.select_your_department')
          })
          .on('change', function (event) {
            var department_id = parseInt(event.val)
            enableAndPopulateJobSiteSelect(department_id, job_sites)
            enableAndPopulatePositionSelect(department_id, positions)
          })

        setUpDepartmentTimeout()
        clearEmployeeIDInterval()

        var idField = $('body.time_clock input#employee_id')
        idField.attr('disabled', 'disabled')

        //$('.separate-sections li').css('width','300px');
        //$('.separate-sections li:last-child').css('width','385px');
        $('.separate-sections li:last-child').addClass('active')
        setClockInButtonLabel(I18n.t('timeclock.js.manual_clock_in'))

        if (len === 1) {
          $('body.time_clock #time-clock-department-filter').val(response.departments[0].id).trigger('change')

          if (job_sites_length === 0 && positions_length === 0) {
            onEmployeeFormSubmit()
          } else {
            enableAndPopulateJobSiteSelect(response.departments[0].id, job_sites)
            enableAndPopulatePositionSelect(response.departments[0].id, positions)
          }
        }
      }
    }
    updateTransferButtonVisibility()
  }

  var enableAndPopulateJobSiteSelect = function (department_id, job_sites) {
    var department_job_sites = _.where(job_sites, { department_id: department_id })
    var job_sites_html = '<option></option>'

    $('body.time_clock #time-clock-job-site-filter').select2('val', '')
    for (var i = 0; i < department_job_sites.length; i++) {
      job_sites_html += '<option value="' + department_job_sites[i].id + '">' + department_job_sites[i].name + '</option>'
    }
    $('body.time_clock #time-clock-job-site-filter').html(job_sites_html)

    if (department_job_sites.length > 0) {
      $('body.time_clock #time-clock-job-site-filter').prop('disabled', false)
      $('body.time_clock #time-clock-job-site-filter').show()
      $('#title-with-job-site').show()
      $('body.time_clock #time-clock-job-site-filter')
        .select2({
          placeholder: I18n.t('timeclock.js.select_job_site'),
          allowClear: true
        })
        .on('change', function () {
          setUpDepartmentTimeout()
          clearEmployeeIDInterval()
        })
    } else {
      $('body.time_clock #time-clock-job-site-filter').select2('destroy')
      $('body.time_clock #time-clock-job-site-filter').hide()
      $('#title-with-job-site').hide()
    }

    setUpDepartmentTimeout()
    clearEmployeeIDInterval()
  }

  var enableAndPopulatePositionSelect = function (department_id, positions) {
    var department_positions = _.where(positions, { department_id: department_id })
    var positions_html = '<option></option>'

    $('body.time_clock #time-clock-position-filter').select2('val', '')
    for (var i = 0; i < department_positions.length; i++) {
      positions_html += '<option value="' + department_positions[i].id + '">' + department_positions[i].name + '</option>'
    }
    $('body.time_clock #time-clock-position-filter').html(positions_html)

    if (department_positions.length > 0) {
      $('body.time_clock #time-clock-position-filter').prop('disabled', false)
      $('body.time_clock #time-clock-position-filter').show()
      $('#title-with-position').show()
      $('body.time_clock #time-clock-position-filter')
        .select2({
          placeholder: I18n.t('timeclock.js.select_position'),
          allowClear: true
        })
        .on('change', function () {
          setUpDepartmentTimeout()
          clearEmployeeIDInterval()
        })
    } else {
      $('body.time_clock #time-clock-position-filter').select2('destroy')
      $('body.time_clock #time-clock-position-filter').hide()
      $('#title-with-position').hide()
    }
  }

  var setUpDepartmentTimeout = function () {
    clearTimeOut()
    timeoutInterval = setInterval(resetDepartmentSelection, timeoutLength)
    initCountdownTimer()
  }

  var resetDepartmentSelection = function () {
    clearTimeOut()
    $('body.time_clock .next-employee-id').addClass('active')
    $('.separate-sections li:last-child').removeClass('active')
    clearEmployeeID()
    clearEmployeeIDInterval()
    $('body.time_clock #time-clock-department-filter').select2('close')
    $('body.time_clock #time-clock-job-site-filter').select2('destroy')
    $('body.time_clock #time-clock-position-filter').select2('destroy')
    //$('.separate-sections li').css('width','385px');
  }

  var onEmployeePunchRetrieveFail = function (error) {
    displayFlashError(I18n.t('errors.error', { message: error.responseJSON.error_message }))
    clearEmployeeIdInterval()
  }

  var showShift = function () {
    $('body.time_clock .employee-id-lookup').removeClass('active')
    $('body.time_clock .punch-card').addClass('active')
    $('body.time_clock .punch-in-card').addClass('active')
    $('body.time_clock .punch-out-card').removeClass('active')
    $('body.time_clock span.title').html('Clock In')

    var endTime
    var startTime
    if (nextShift != null) {
      endTime = moment.unix(nextShift.ends_at).tz(getDepartmentTimeZone(nextShift.department_id)).format('h:mm A')
      startTime = moment.unix(nextShift.starts_at).tz(getDepartmentTimeZone(nextShift.department_id)).format('h:mm A')
      if (nextShift.hide_ends_at == true || nextShift.hide_ends_at == 'true') {
        endTime = I18n.t('timeclock.js.to_be_determined')
      }

      $('body.time_clock .nameAndTime').html(
        currentUser.name + ' <div class="shift-details"><span class="medium-text">' + startTime + ' - ' + endTime + '</span></div>'
      )
    } else {
      $('body.time_clock .nameAndTime').html(currentUser.name)
    }

    var dept
    var job_site_id
    var position_id
    if (nextShift != null) {
      dept = getDepartmentName(nextShift.department_id)
      job_site_id = nextShift.job_site_id
      position_id = nextShift.position_id
    } else {
      var deptField = $('body.time_clock select#time-clock-department-filter')
      dept = getDepartmentName(deptField.val())
      job_site_id = parseInt($('body.time_clock select#time-clock-job-site-filter').val())
      position_id = parseInt($('body.time_clock select#time-clock-position-filter').val())
    }

    if (dept != null) {
      if (nextShift != null) {
        $('body.time_clock .date').html(
          '<span class="punch-card-label">' +
            I18n.t('timeclock.js.date') +
            '</span><span class="punch-card-value">' +
            moment.unix(nextShift.starts_at).format(I18n.t('date.formats.moment')) +
            '</span>'
        )
      } else {
        $('body.time_clock .date').html(
          '<span class="punch-card-label">' +
            I18n.t('timeclock.js.date') +
            '</span><span class="punch-card-value">' +
            moment().format(I18n.t('date.formats.moment')) +
            '</span>'
        )
      }
      $('body.time_clock .department').html(
        '<span class="punch-card-label">' +
          I18n.t('timeclock.js.department') +
          '</span><span class="punch-card-value">' +
          truncateString(dept.name, 25) +
          '</span>'
      )

      if (job_site_id) {
        var job_site_name = _.find(job_sites, { id: job_site_id }).name
        $('body.time_clock .job_site').html(
          '<span class="punch-card-label">' +
            I18n.t('timeclock.js.job_site') +
            '</span><span class="punch-card-value"> ' +
            truncateString(job_site_name, 25) +
            '</span>'
        )
      }

      if (position_id) {
        var position_name = _.find(positions, { id: position_id }).name
        $('body.time_clock .position').html(
          '<span class="punch-card-label">' +
            I18n.t('timeclock.js.position') +
            '</span><span class="punch-card-value"> ' +
            truncateString(position_name, 25) +
            '</span>'
        )
      }

      if (nextShift && nextShift.breaks != null) {
        $('body.time_clock .breaks').html(getBreaksList(nextShift.breaks))
      }

      var location = getLocationById(dept.location_id)
      if (location != null) {
        // Default behavior - hide break buttons
        $('body.time_clock .start-break-card').removeClass('active')
        $('body.time_clock .start-break').removeClass('active')
        $('body.time_clock .clock-out-employee-id').addClass('active')

        // Check if location requires break punches
        if (location.requires_break_punches) {
          // Even if it requires break punches, check it's not using auto-deduct breaks
          if (!location.auto_unpaid_breaks) {
            // Only show break buttons when both conditions are met:
            // 1. Location requires break punches
            // 2. Location does NOT use auto-deduct breaks
            if (breakPunch) {
              // Employee is currently on a break - show end break button
              $('body.time_clock .clocked-in-at').append(
                '<br><span class="break-started-at-details">' +
                  I18n.t('timeclock.js.started_break_at') +
                  moment.unix(breakPunch.starts_at).tz(getDepartmentTimeZone(currentPunch.department_id)).format('h:mm A') +
                  '</span>'
              )
              $('body.time_clock .clock-out-employee-id').removeClass('active')
              $('body.time_clock button.clock-out-employee-id').prop('disabled', false)
              $('body.time_clock .end-break').addClass('active')

              $('body.time_clock .transfer-employee-id').hide()
            } else {
              // Employee is not on break - show start break button
              $('body.time_clock .start-break-card').addClass('active')
              $('body.time_clock .start-break').addClass('active')
              $('body.time_clock .clock-out-employee-id').addClass('active')
              $('body.time_clock .end-break').removeClass('active')
              $('body.time_clock button.start-break').prop('disabled', false)

              $('body.time_clock .transfer-employee-id').show()
            }
          }
          // If auto_unpaid_breaks is true, we keep the default behavior (break buttons hidden)
        }
        // If location doesn't require break punches, we keep the default behavior (break buttons hidden)
      }
    }

    clearTimeOut()
    timeoutInterval = setInterval(resetClockInFlow, timeoutLength)
    initCountdownTimer()
  }

  var showPunch = function () {
    $('body.time_clock .employee-id-lookup').removeClass('active')
    $('body.time_clock .punch-card').addClass('active')
    $('body.time_clock .punch-in-card').removeClass('active')
    $('body.time_clock .punch-out-card').addClass('active')
    $('body.time_clock span.title').html('Clock Out')

    var endTime
    var startTime
    if (!_.isUndefined(nextShift) && nextShift !== null) {
      endTime = moment.unix(nextShift.ends_at).tz(getDepartmentTimeZone(nextShift.department_id)).format('h:mm A')
      startTime = moment.unix(nextShift.starts_at).tz(getDepartmentTimeZone(nextShift.department_id)).format('h:mm A')
      if (nextShift.hide_ends_at == true || nextShift.hide_ends_at == 'true') {
        endTime = I18n.t('timeclock.js.to_be_determined')
      }

      $('body.time_clock .nameAndTime').html(
        currentUser.name +
          '<p class="clocked-in-at">' +
          I18n.t('timeclock.js.clocked_in_at', {
            time: moment.unix(currentPunch.punched_in_at).tz(getDepartmentTimeZone(currentPunch.department_id)).format('h:mm A')
          }) +
          '</p> <div class="shift-details"><span class="medium-text">' +
          startTime +
          ' - ' +
          endTime +
          '</span></div>'
      )
    } else {
      $('body.time_clock .nameAndTime').html(
        currentUser.name +
          '<p class="clocked-in-at">' +
          I18n.t('timeclock.js.clocked_in_at', {
            time: moment.unix(currentPunch.punched_in_at).tz(getDepartmentTimeZone(currentPunch.department_id)).format('h:mm A')
          }) +
          '</p>'
      )
    }

    var dept = getDepartmentById(currentPunch.department_id)
    var location = getLocationById(dept.location_id)
    if (location != null) {
      // Default behavior - hide break buttons
      $('body.time_clock .start-break-card').removeClass('active')
      $('body.time_clock .start-break').removeClass('active')
      $('body.time_clock .clock-out-employee-id').addClass('active')
      $('body.time_clock button.clock-out-employee-id').prop('disabled', false)

      // Check if location requires break punches
      if (location.requires_break_punches) {
        // Even if it requires break punches, check it's not using auto-deduct breaks
        if (!location.auto_unpaid_breaks) {
          // Only show break buttons when both conditions are met:
          // 1. Location requires break punches
          // 2. Location does NOT use auto-deduct breaksΩ
          if (breakPunch) {
            // Employee is currently on a break - show end break button
            $('body.time_clock .clocked-in-at').append(
              '<br><span class="break-started-at-details">' +
                I18n.t('timeclock.js.started_break_at') +
                moment.unix(breakPunch.starts_at).tz(getDepartmentTimeZone(currentPunch.department_id)).format('h:mm A') +
                '</span>'
            )
            $('body.time_clock .clock-out-employee-id').removeClass('active')
            $('body.time_clock .end-break').addClass('active')
            $('body.time_clock button.end-break').prop('disabled', false)
          } else {
            // Employee is not on break - show start break button
            $('body.time_clock .start-break-card').addClass('active')
            $('body.time_clock .start-break').addClass('active')
            $('body.time_clock .clock-out-employee-id').addClass('active')
            $('body.time_clock .end-break').removeClass('active')
            $('body.time_clock button.end-break').prop('disabled', true)
            $('body.time_clock button.start-break').prop('disabled', false)
          }
        }
        // If auto_unpaid_breaks is true, we keep the default behavior (break buttons hidden)
      }
      // If location doesn't require break punches, we keep the default behavior (break buttons hidden)
    }

    dept = getDepartmentName(currentPunch.department_id)
    if (dept != null) {
      if (!_.isUndefined(nextShift) && nextShift !== null) {
        $('body.time_clock .date').html(
          '<span class="punch-card-label">' +
            I18n.t('timeclock.js.date') +
            '</span><span class="punch-card-value">' +
            moment.unix(nextShift.starts_at).format(I18n.t('date.formats.moment')) +
            '</span>'
        )
      } else {
        $('body.time_clock .date').html(
          '<span class="punch-card-label">' +
            I18n.t('timeclock.js.date') +
            '</span><span class="punch-card-value">' +
            moment.unix(currentPunch.punched_in_at).format(I18n.t('date.formats.moment')) +
            '</span>'
        )
      }
      $('body.time_clock .department').html(
        '<span class="punch-card-label">' +
          I18n.t('timeclock.js.department') +
          '</span><span class="punch-card-value">' +
          truncateString(dept.name, 25) +
          '</span>'
      )

      var job_site_id = currentPunch.job_site_id
      if (job_site_id) {
        var job_site_name = _.find(job_sites, { id: job_site_id }).name
        $('body.time_clock .job_site').html(
          '<span class="punch-card-label">' +
            I18n.t('timeclock.js.job_site') +
            '</span><span class="punch-card-value"> ' +
            truncateString(job_site_name, 25) +
            '</span>'
        )
      }

      var position_id = currentPunch.position_id
      if (position_id) {
        var position_name = _.find(positions, { id: position_id }).name
        $('body.time_clock .position').html(
          '<span class="punch-card-label">' +
            I18n.t('timeclock.js.position') +
            '</span><span class="punch-card-value"> ' +
            truncateString(position_name, 25) +
            '</span>'
        )
      }

      if (nextShift && nextShift.breaks != null) {
        $('body.time_clock .breaks').html(getBreaksList(nextShift.breaks))
      }
    }

    clearTimeOut()
    timeoutInterval = setInterval(resetClockInFlow, timeoutLength)
    initCountdownTimer()
    updateTransferButtonVisibility()
  }

  var clearFlashInterval = function () {
    if (flashInterval != null) {
      clearInterval(flashInterval)
      flashInterval = null
    }
  }

  var clearTimeOut = function () {
    if (timeoutInterval != null) {
      clearInterval(timeoutInterval)
      timeoutInterval = null
    }

    if (countdownInterval != null) {
      clearInterval(countdownInterval)
      countdownInterval = null
      $('.time-interval-warning label').text('')
    }
  }

  var displayFlashError = function (msg) {
    if (!_.isEmpty(msg)) {
      var flashHTML = '<div class="alert alert-error"><a class="close" data-dismiss="alert">×</a><div id="flash_error">' + msg + '</div></div>'
      $('body.time_clock #flash-messages').html(flashHTML)
    }
    clearFlashInterval()
    flashInterval = setInterval(clearFlashMessage, 10000)
  }

  var displayFlashSuccess = function (msg) {
    if (!_.isEmpty(msg)) {
      var flashHTML = '<div class="alert alert-success"><a class="close" data-dismiss="alert">×</a><div id="flash_success">' + msg + '</div></div>'
      $('body.time_clock #flash-messages').html(flashHTML)
    }
    clearFlashInterval()
    flashInterval = setInterval(clearFlashMessage, 10000)
  }

  var clearFlashMessage = function () {
    $('body.time_clock #flash-messages').html('')
  }

  var clearEmployeeIdInterval = function () {
    clearEmployeeInterval()
    clearIDInterval = setInterval(clearEmployeeID, 10000)
    initCountdownTimer()
  }

  var clearEmployeeInterval = function () {
    if (clearIDInterval != null) {
      clearInterval(clearIDInterval)
      clearIDInterval = null
    }
  }

  var clearEmployeeID = function () {
    var idField = $('body.time_clock input#employee_id')
    idField.removeAttr('disabled')
    idField.val('')
    idField.focus()
  }

  var setUpTimeoutInterval = function () {
    clearEmployeeIDInterval()
    employeeIDInterval = setInterval(resetEmployeeID, timeoutLength)
    initCountdownTimer()
  }

  var clearEmployeeIDInterval = function () {
    if (employeeIDInterval != null) {
      clearInterval(employeeIDInterval)
      employeeIDInterval = null
    }
  }

  var resetEmployeeID = function () {
    clearEmployeeID()
  }

  var setUpClearPasswordInterval = function () {
    clearPasswordInterval = setInterval(passwordEntryTimedOut, timeoutLength)
    initCountdownTimer()
  }

  var clearPasswordTimeout = function () {
    if (clearPasswordInterval != null) {
      clearInterval(clearPasswordInterval)
      clearPasswordInterval = null

      setUpClearPasswordInterval()
    }
  }

  var passwordEntryTimedOut = function () {
    var passwordScreen = $('.time_clock.time_clock_sign_out.show')
    if (_.isElement(passwordScreen[0])) {
      var cancelButton = $('button.cancel-clock-in', passwordScreen)
      cancelButton.click()
    }
  }

  var initCountdownTimer = function () {
    if (countdownInterval != null) {
      clearInterval(countdownInterval)
      countdownInterval = null
      $('.time-interval-warning label').text('')
    }

    countdownTimerLength = 14000
    countdownInterval = setInterval(countdownTimer, 1000)
  }

  var countdownTimer = function () {
    if (countdownTimerLength < 10000) {
      var seconds = parseInt(Math.round(countdownTimerLength / 1000), 10)
      $('.time-interval-warning label').text(I18n.t('timeclock.js.dismiss_in_seconds', { seconds: seconds }))
    }

    if (countdownTimerLength === 0) {
      clearInterval(countdownInterval)
      $('.time-interval-warning label').text('')
      resetClockInFlow()
    }

    if ((countdownTimerLength -= 1000) < 1000) {
      countdownTimerLength = 0
    }
  }

  /**
   * Displays transfer options UI
   * Shows buttons for scheduled and unscheduled transfers
   * @param {Event} e - The event object
   */
  var showTransferOptions = function (e) {
    // Remove any duplicate user info elements
    $('.transfer-options-card .nameAndTime').remove()
    $('body.time_clock .punch-card').find('.nameAndTime').not(':first').remove()

    // Hide the punch-out-card without hiding the user info at the top
    $('body.time_clock .punch-out-card').removeClass('active')

    // Hide all action buttons
    $('.normal-buttons').addClass('hidden')

    // Hide any other forms
    $('form.employee-id-lookup').removeClass('active')
    $('.upcoming-shifts-container').removeClass('active')

    // Ensure the punch card remains visible
    $('body.time_clock .punch-card').addClass('active')

    // Show only the transfer options card
    showComponent('body.time_clock .transfer-options-card')

    // Reset timeouts
    clearTimeOut()
    timeoutInterval = setInterval(resetClockInFlow, timeoutLength)
    initCountdownTimer()

    e.preventDefault()
  }

  /**
   * Handles the cancel button for transfer operation
   * Returns the UI to normal punch-out state
   * @param {Event} e - The event object
   */
  var cancelTransfer = function (e) {
    // Hide all transfer-related elements
    hideComponent('body.time_clock .transfer-options-card')
    $('.transfer-options-card').css('display', 'none')
    $('.upcoming-shifts-container').removeClass('active')
    $('form.employee-id-lookup').removeClass('active')

    // Show the punch card with user info
    $('body.time_clock .punch-card').addClass('active')
    $('body.time_clock .punch-out-card').addClass('active')

    // Show normal buttons
    $('.normal-buttons').removeClass('hidden')

    // Reset timeouts
    clearTimeOut()
    timeoutInterval = setInterval(resetClockInFlow, timeoutLength)
    initCountdownTimer()

    e.preventDefault()
  }

  /**
   * Manages transfer button visibility based on all required conditions
   * Should be called whenever any of the state that affects visibility changes
   */
  var updateTransferButtonVisibility = function () {
    var transferButton = $('body.time_clock .transfer-employee-id')

    // Default to hiding the button
    transferButton.hide()

    // Only show if all conditions are met:
    // 1. We have a current punch
    // 2. The punch is not already transferred
    // 3. The user is not on a break
    if (currentPunch && !currentPunch.isTransferred && !breakPunch) {
      // Note: The allow_position_transfer setting is already checked in the ERB template
      // If that setting is false, the button won't be in the DOM at all
      transferButton.show()
    }
  }

  /**
   * Fetches and displays upcoming shifts for transfer
   * Loads potential shifts from API and renders them for selection
   * @param {Event} e - The event object
   */
  var showUpcomingShifts = function (e) {
    // Validate current punch exists
    if (!currentPunch || !currentPunch.id) {
      displayFlashError(I18n.t('timeclock.js.punch_info_unavailable'))
      resetClockInFlow()
      return
    }

    // Hide transfer options
    hideComponent('body.time_clock .transfer-options-card')

    // Show loading indicator
    displayFlashSuccess(I18n.t('timeclock.js.loading_shifts'))

    // Fetch upcoming shifts from API
    var url = getBaseDomain() + 'api/live/v3/kiosk_punches/upcoming_shift?user_id=' + currentUser.id
    setEndpointHeaders()

    $.ajax({
      method: 'GET',
      dataType: 'json',
      contentType: 'application/json',
      url: url,
      success: function (response) {
        onUpcomingShiftSuccess(response)
      },
      error: onUpcomingShiftFail
    })

    e.preventDefault()
  }

  // Process upcoming shifts response
  var onUpcomingShiftSuccess = function (response) {
    // Clear previous UI state
    hideComponent('body.time_clock .transfer-options-card')
    clearFlashMessage()

    // Check if we got a shift
    if (!response || !response.upcoming_shift) {
      displayFlashError(I18n.t('timeclock.js.no_upcoming_shift'))
      document.querySelector('body.time_clock .punch-out-card').classList.add('active')
      document.querySelector('.normal-buttons').classList.remove('hidden')
      return
    }

    try {
      var shift = response.upcoming_shift

      // Store the shift for direct submission
      window.selectedShiftForTransfer = shift

      // Format times for display with better handling of different timestamp formats
      var startTime, endTime
      if (shift.start_time) {
        startTime = moment(shift.start_time).format('h:mm A')
      } else if (shift.starts_at) {
        startTime = moment.unix(shift.starts_at).tz(getDepartmentTimeZone(shift.department_id)).format('h:mm A')
      }

      if (shift.hide_end_time || shift.hide_ends_at) {
        endTime = I18n.t('timeclock.js.to_be_determined')
      } else if (shift.end_time) {
        endTime = moment(shift.end_time).format('h:mm A')
      } else if (shift.ends_at) {
        endTime = moment.unix(shift.ends_at).tz(getDepartmentTimeZone(shift.department_id)).format('h:mm A')
      }

      // Hide the punch card elements that aren't needed
      hideComponent('body.time_clock .punch-card')

      // Show the upcoming shifts container
      document.querySelector('.upcoming-shifts-container').classList.add('active')
      document.querySelector('.upcoming-shifts-container').style.display = 'block'

      // Create the upcoming shifts container content in the same format as the clock-in card
      var shiftsHtml = '<p class="nameAndTime">' + currentUser.name
      shiftsHtml += '<div class="shift-details"><span class="medium-text">' + startTime + ' - ' + endTime + '</span></div></p>'

      // Display error message if needed
      shiftsHtml += '<div class="error-message" style="color:#ff5555; padding: 10px; margin: 10px auto; max-width: 80%; display: none;"></div>'

      // Add data container with similar format to punch card - keep original styling
      shiftsHtml += '<div id="punch-card-data-container" style="margin-left: auto; margin-right: auto;">'

      // Add date info
      shiftsHtml += '<p class="punch-card-data-item date">'
      shiftsHtml += '<span class="punch-card-label" style="padding-top: 0px;">' + I18n.t('timeclock.js.date') + '</span>'
      // Handle different date formats
      if (shift.start_time) {
        shiftsHtml +=
          '<span class="punch-card-value" style="padding-top: 0px;">' + moment(shift.start_time).format(I18n.t('date.formats.moment')) + '</span>'
      } else if (shift.starts_at) {
        shiftsHtml +=
          '<span class="punch-card-value" style="padding-top: 0px;">' + moment.unix(shift.starts_at).format(I18n.t('date.formats.moment')) + '</span>'
      }
      shiftsHtml += '</p>'

      // Add department info if available
      if (shift.department_id) {
        var dept = _.find(departments, { id: shift.department_id })
        if (dept) {
          shiftsHtml += '<p class="punch-card-data-item department">'
          shiftsHtml += '<span class="punch-card-label" style="padding-top: 20px;">' + I18n.t('timeclock.js.department') + '</span>'
          shiftsHtml += '<span class="punch-card-value" style="padding-top: 20px;">' + truncateString(dept.name, 25) + '</span>'
          shiftsHtml += '</p>'
        }
      }

      // Improved job site info handling with better fallbacks
      if (shift.job_site_id) {
        var job_site = _.find(job_sites, { id: shift.job_site_id })
        if (job_site) {
          shiftsHtml += '<p class="punch-card-data-item job_site">'
          shiftsHtml += '<span class="punch-card-label" style="padding-top: 20px;">' + I18n.t('timeclock.js.job_site') + '</span>'
          shiftsHtml += '<span class="punch-card-value" style="padding-top: 20px;">' + truncateString(job_site.name, 25) + '</span>'
          shiftsHtml += '</p>'
        }
      } else if (shift.job_site && typeof shift.job_site === 'object') {
        // Handle case where job_site object is directly provided
        shiftsHtml += '<p class="punch-card-data-item job_site">'
        shiftsHtml += '<span class="punch-card-label" style="padding-top: 20px;">' + I18n.t('timeclock.js.job_site') + '</span>'
        shiftsHtml += '<span class="punch-card-value" style="padding-top: 20px;">' + truncateString(shift.job_site.name, 25) + '</span>'
        shiftsHtml += '</p>'
      } else if (shift.job_site && typeof shift.job_site === 'string') {
        shiftsHtml += '<p class="punch-card-data-item job_site">'
        shiftsHtml += '<span class="punch-card-label" style="padding-top: 20px;">' + I18n.t('timeclock.js.job_site') + '</span>'
        shiftsHtml += '<span class="punch-card-value" style="padding-top: 20px;">' + truncateString(shift.job_site, 25) + '</span>'
        shiftsHtml += '</p>'
      }

      // Improved position info handling with better fallbacks
      if (shift.position && typeof shift.position === 'object') {
        shiftsHtml += '<p class="punch-card-data-item position">'
        shiftsHtml += '<span class="punch-card-label" style="padding-top: 20px;">' + I18n.t('timeclock.js.position') + '</span>'
        shiftsHtml += '<span class="punch-card-value" style="padding-top: 20px;"> ' + truncateString(shift.position.name, 25) + '</span>'
        shiftsHtml += '</p>'
      } else if (shift.position && typeof shift.position === 'string') {
        shiftsHtml += '<p class="punch-card-data-item position">'
        shiftsHtml += '<span class="punch-card-label" style="padding-top: 20px;">' + I18n.t('timeclock.js.position') + '</span>'
        shiftsHtml += '<span class="punch-card-value" style="padding-top: 20px;"> ' + truncateString(shift.position, 25) + '</span>'
        shiftsHtml += '</p>'
      } else if (shift.position_id) {
        var position = _.find(positions, { id: shift.position_id })
        if (position) {
          shiftsHtml += '<p class="punch-card-data-item position">'
          shiftsHtml += '<span class="punch-card-label" style="padding-top: 20px;">' + I18n.t('timeclock.js.position') + '</span>'
          shiftsHtml += '<span class="punch-card-value" style="padding-top: 20px;"> ' + truncateString(position.name, 25) + '</span>'
          shiftsHtml += '</p>'
        }
      }

      // Improved break information handling
      if (shift.breaks) {
        try {
          // Handle both array and string format
          var breaks = Array.isArray(shift.breaks) ? shift.breaks : typeof shift.breaks === 'string' ? JSON.parse(shift.breaks) : shift.breaks
          if (breaks && breaks.length > 0) {
            // Use the same class structure as the other fields, including department class to get correct styling
            shiftsHtml += '<p class="punch-card-data-item breaks department">'

            // FIX: Use the correct translation key "BREAKS" (uppercase) or a hardcoded string if needed
            shiftsHtml += '<span class="punch-card-label" style="padding-top: 20px;">' + I18n.t('timeclock.js.breaks') + '</span>'

            // Add the value
            shiftsHtml += '<span class="punch-card-value" style="padding-top: 20px;">'

            // Format break times with consistent styling
            var items_per_row = 0
            for (var i = 0; i < breaks.length; i++) {
              if (i > 0 && items_per_row != 3) {
                shiftsHtml += ', '
              }
              if (items_per_row == 3) {
                shiftsHtml += '<br>'
                items_per_row = 0
              }
              shiftsHtml += msUtil.durationToMinutes(breaks[i], true, ' min')
              items_per_row++
            }

            // Close the spans
            shiftsHtml += '</span>'
            shiftsHtml += '</p>'
          }
        } catch (e) {
          console.log(e)
        }
      }

      // Close data container
      shiftsHtml += '</div>'

      // Add form with hidden input for shift ID
      shiftsHtml += '<form id="transfer-shift-form">'
      shiftsHtml += '<input type="hidden" name="shift_id" value="' + shift.id + '">'

      // Add buttons styled like the clock-in buttons - keep original styling
      shiftsHtml += '<div class="normal-buttons" style="display: flex; justify-content: center;">'
      shiftsHtml += '<button type="button" class="btn btn-blue cancel-upcoming-shift">' + I18n.t('buttons.cancel') + '</button>'
      shiftsHtml += '<button type="button" class="btn btn-blue submit-upcoming-shift">' + I18n.t('time_clock.kiosks.submit_transfer') + '</button>'
      shiftsHtml += '</div>'
      shiftsHtml += '</form>'

      // Update the HTML content
      document.querySelector('.upcoming-shifts-container').innerHTML = shiftsHtml

      // Add event handlers for the buttons
      var cancelButton = document.querySelector('.cancel-upcoming-shift')
      if (cancelButton) {
        cancelButton.removeEventListener('click', cancelUpcomingShift)
        cancelButton.addEventListener('click', cancelUpcomingShift)
      }

      var submitButton = document.querySelector('.submit-upcoming-shift')
      if (submitButton) {
        submitButton.removeEventListener('click', submitUpcomingShift)
        submitButton.addEventListener('click', submitUpcomingShift)
      }

      // Set up timeouts
      clearTimeOut()
      timeoutInterval = setInterval(resetClockInFlow, timeoutLength)
      initCountdownTimer()
    } catch (error) {
      displayFlashError(I18n.t('errors.error', { message: 'An unexpected error occurred' }))
    }
  }

  // Handle upcoming shift selection failure
  var onUpcomingShiftFail = function (error) {
    let errorMessage = I18n.t('timeclock.js.error_fetching_shifts')

    if (error.responseJSON && error.responseJSON.error_message) {
      errorMessage = error.responseJSON.error_message
    }

    displayFlashError('Error: ' + errorMessage)

    // Show normal buttons
    $('.normal-buttons').removeClass('hidden')

    $('body.time_clock .punch-out-card').addClass('active')
    timeoutInterval = setInterval(resetClockInFlow, 10000)
  }

  /**
   * Displays unscheduled shift transfer options
   * Shows department selection form for unscheduled transfers
   * @param {Event} e - The event object
   */
  var showUnscheduledShiftOptions = function (e) {
    // Reset any existing transfer state first
    window.transfer_mode = false

    // Hide transfer options
    hideComponent('body.time_clock .transfer-options-card')

    // Hide the punch card during department selection
    $('body.time_clock .punch-card').removeClass('active')

    // Verify departments are available
    if (!departments || departments.length === 0) {
      displayFlashError(I18n.t('timeclock.js.dept_info_unavailable'))
      $('.normal-buttons').removeClass('hidden')
      $('body.time_clock .punch-out-card').addClass('active')
      return
    }

    // Show the department selection form
    $('form.employee-id-lookup').addClass('active').show()

    // Hide the employee ID input and show only the department selection
    $('.separate-sections li:first-child').hide()
    $('.separate-sections li:last-child').addClass('active').show()

    // Populate department dropdown
    var html = '<option></option>'
    for (var i = 0; i < departments.length; i++) {
      html += '<option value="' + departments[i].id + '">' + departments[i].name + '</option>'
    }

    $('body.time_clock #time-clock-department-filter').html(html)
    $('body.time_clock #time-clock-department-filter')
      .select2({
        placeholder: I18n.t('timeclock.js.select_your_department')
      })
      .on('change', function (event) {
        var department_id = parseInt(event.val)
        enableAndPopulateJobSiteSelect(department_id, job_sites)
        enableAndPopulatePositionSelect(department_id, positions)
      })

    // Set transfer mode flag
    window.transfer_mode = true

    // Update submit button text and handler for transfer mode
    var submitButton = $('body.time_clock .submit-employee-id')
    submitButton.text(I18n.t('time_clock.kiosks.submit_transfer'))
    submitButton.attr('data-transfer-button', 'true')
    submitButton.off('click').on('click', submitUnscheduledTransfer)

    e.preventDefault()
  }

  /**
   * Process unscheduled transfer submission
   * Sends unscheduled transfer request to the API
   * @param {Event} e - The event object
   */
  var submitUnscheduledTransfer = function (e) {
    if (!currentPunch || !currentPunch.id) {
      displayFlashError(I18n.t('timeclock.js.punch_info_unavailable'))
      resetClockInFlow()
      return
    }

    var deptField = $('body.time_clock select#time-clock-department-filter')
    var job_site_id = $('body.time_clock select#time-clock-job-site-filter').val()
    var position_id = $('body.time_clock select#time-clock-position-filter').val()

    if (deptField.val().trim() == '') {
      displayFlashError(I18n.t('timeclock.js.please_select_dept'))
      return
    }

    // Uses public API endpoint for unscheduled transfers
    var url = getBaseDomain() + 'api/public/v3/punch/transfer/unscheduled'
    // Formats data in JSON:API format
    var sendData = {
      data: {
        type: 'punch_transfer',
        attributes: {
          from_punch_id: currentPunch.id,
          department_id: deptField.val(),
          user_id: currentUser.id,
          job_site_id: job_site_id || null,
          position_id: position_id || null,
          disable_photo_punches: true
        }
      }
    }

    $.ajax({
      method: 'POST',
      dataType: 'json',
      contentType: 'application/vnd.api+json',
      url: url,
      data: JSON.stringify(sendData),
      headers: {
        Authorization: 'Token ' + document.ctoken,
        'X-APP-NAME': window.server_config.admin_mobile_app || 'makeshift_live',
        'X-APP-VERSION': '2.7.0',
        'X-DEVICE-TYPE': 'ios'
      },
      success: onTransferSuccess,
      error: onTransferFail
    })

    e.preventDefault()
  }

  /**
   * Process upcoming shift transfer submission
   * Sends scheduled transfer request to the API
   * @param {Event} e - The event object
   */
  var submitUpcomingShift = function (e) {
    // Validates current punch exists
    if (!currentPunch || !currentPunch.id) {
      displayFlashError(I18n.t('timeclock.js.punch_info_unavailable'))
      resetClockInFlow()
      return
    }

    // Use the shift we stored when showing the upcoming shift
    // This allows users to click submit directly without selecting anything
    var shift = window.selectedShiftForTransfer

    if (!shift || !shift.id) {
      // Display error in the error message container
      var errorContainer = document.querySelector('.upcoming-shifts-container .error-message')
      if (errorContainer) {
        errorContainer.textContent = I18n.t('timeclock.js.please_select_shift')
        errorContainer.style.display = 'block'
      } else {
        // Fallback to the popup message if container not found
        displayFlashError(I18n.t('timeclock.js.please_select_shift'))
      }
      return
    }

    // Disable button to prevent multiple submissions
    var submitButton = document.querySelector('.submit-upcoming-shift')
    if (submitButton) {
      submitButton.disabled = true
      submitButton.textContent = 'Processing...'
    }

    // Uses public API endpoint for scheduled transfers
    var url = getBaseDomain() + 'api/public/v3/punch/transfer/scheduled'

    // Formats data in JSON:API format
    var sendData = {
      data: {
        type: 'punch_transfer',
        attributes: {
          from_punch_id: currentPunch.id,
          shift_id: shift.id,
          user_id: currentUser.id,
          disable_photo_punches: true
        }
      }
    }

    $.ajax({
      method: 'POST',
      dataType: 'json',
      contentType: 'application/vnd.api+json',
      url: url,
      data: JSON.stringify(sendData),
      headers: {
        Authorization: 'Token ' + document.ctoken,
        'X-APP-NAME': window.server_config.admin_mobile_app || 'makeshift_live',
        'X-APP-VERSION': '2.7.0',
        'X-DEVICE-TYPE': 'ios'
      },
      success: onTransferSuccess,
      error: onTransferFail
    })

    e.preventDefault()
  }

  /**
   * Handle successful transfer
   * Displays success message and resets UI
   * @param {Object} response - The API response
   */
  var onTransferSuccess = function (response) {
    // Clear the stored shift reference
    window.selectedShiftForTransfer = null

    // Update the punch information based on the API response
    if (response && response.data && response.data.attributes) {
      // If the API returns the updated punch directly
      if (currentPunch) {
        currentPunch.isTransferred = true
      }
    }

    // Update button visibility
    updateTransferButtonVisibility()

    displayFlashSuccess(
      I18n.t('timeclock.js.transfer_success', {
        user_name: '<strong>' + currentUser.name + '</strong>',
        time: '<strong>' + moment().format('h:mm A') + '</strong>'
      })
    )
    window.transfer_mode = false
    resetClockInFlow(true)
  }

  /**
   * Handle transfer failure
   * Extracts error message and displays to user
   * @param {Object} error - The error object from the AJAX request
   */
  var onTransferFail = function (error) {
    let errorMessage = I18n.t('timeclock.js.error_processing_transfer')

    // Handle JSON:API error format
    if (error.responseJSON && error.responseJSON.errors) {
      const errors = error.responseJSON.errors
      if (errors.length > 0) {
        errorMessage = errors[0].detail || errors[0].title || errorMessage
      }
    }
    // Handle legacy error format
    else if (error.responseJSON && error.responseJSON.error_message) {
      errorMessage = error.responseJSON.error_message
    }

    // Re-enable the submit button if we're still on the screen
    var submitButton = document.querySelector('.submit-upcoming-shift')
    if (submitButton) {
      submitButton.disabled = false
      submitButton.textContent = I18n.t('time_clock.kiosks.submit_transfer')

      // Try to show error in the error container
      var errorContainer = document.querySelector('.upcoming-shifts-container .error-message')
      if (errorContainer) {
        errorContainer.textContent = 'Error: ' + errorMessage
        errorContainer.style.display = 'block'
        // Don't reset the flow immediately
        return
      }
    }

    // Show normal buttons
    $('.normal-buttons').removeClass('hidden')

    displayFlashError('Error: ' + errorMessage)
    resetClockInFlow(true)
  }

  // Cancel upcoming shift selection
  var cancelUpcomingShift = function (e) {
    // Hide upcoming shifts container
    document.querySelector('.upcoming-shifts-container').classList.remove('active')
    document.querySelector('.upcoming-shifts-container').style.display = 'none'

    // Show the punch card with user info
    document.querySelector('body.time_clock .punch-card').classList.add('active')
    document.querySelector('body.time_clock .punch-out-card').classList.add('active')

    // Show normal buttons
    document.querySelector('.normal-buttons').classList.remove('hidden')

    e.preventDefault()
  }

  // Returns span wrapped list of scheduled breaks
  // We are limiting 3 breaks per line.
  var getBreaksList = function (breaks) {
    var str = ''
    if (breaks.length > 0) {
      str += '<span class="punch-card-label">' + I18n.t('timeclock.js.breaks') + '</span><span class="punch-card-value">'
      var items_per_row = 0
      for (var i = 0; i < breaks.length; i++) {
        if (i > 0 && items_per_row != 3) {
          str += ', '
        }
        if (items_per_row == 3) {
          str += '<br>'
          items_per_row = 0
        }
        str += msUtil.durationToMinutes(breaks[i], true, ' min')
        items_per_row++
      }
      str += '</span>'
    }

    return str
  }

  $(document).on('load.time_clock.show', initTimeClock)
  $(document).on('load.time_clock.time_clock_sign_out.show', init)
})(jQuery, window)

function truncateString(str, num) {
  if (num < str.length) {
    return str.slice(0, num) + '...'
  } else {
    return str
  }
}
